import { axios } from '@/plugins/axios';

export default class MSzafirService
{
    public static async initSignature(licence: string, publicId: string, endpointId: string): Promise<InitSignatureResponse>
    {
        return (await axios.post(`signatures/mszafir/${licence}/${publicId}/${endpointId}/init`)).data;
    }
}

export interface InitSignatureResponse
{
    signingId: string;
    fileIds: string[];
    loginToken: string;
    statusCode: number;
    status: string;
    loginHAuth: string;
    loginUrl: string;
}
